import { createIcon } from '@chakra-ui/icons';

export const HomeIcon = createIcon({
  displayName: 'HomeIcon',
  viewBox: '0 0 23 20',
  d: 'M22.524 9.83614L12.0738 0.21903C11.9986 0.149598 11.9092 0.0945134 11.8108 0.0569295C11.7125 0.0193456 11.607 0 11.5005 0C11.394 0 11.2885 0.0193456 11.1901 0.0569295C11.0917 0.0945134 11.0023 0.149598 10.9271 0.21903L0.476967 9.83614C0.17252 10.1165 0 10.4974 0 10.8946C0 11.7194 0.728135 12.39 1.62372 12.39H2.7248V19.2523C2.7248 19.6659 3.0876 20 3.53666 20H9.87676V14.7662H12.7183V20H19.4643C19.9134 20 20.2762 19.6659 20.2762 19.2523V12.39H21.3772C21.8085 12.39 22.2221 12.2334 22.5265 11.9507C23.1582 11.3666 23.1582 10.4203 22.524 9.83614Z',
});
